export interface Bonus {
  label: string
  title: string
  body: string
}

export const bonuses: Bonus[] = [
  {
    label: '🎁 BONUS 1',
    title: 'APPLIANCE FAULT QUICK REFERENCE GUIDE™',
    body: 'Quickly review common appliance symptoms, possible causes, component checkpoints, first checks, diagnostic sequences, and essential fault-finding references.',
  },
  {
    label: '🎁 BONUS 2',
    title: 'COMPONENT TESTING REFERENCE™',
    body: 'Identify and evaluate common switches, sensors, thermostats, heating elements, motors, pumps, valves, relays, thermal protection devices, wiring, connectors, and other appliance components.',
  },
  {
    label: '🎁 BONUS 3',
    title: 'SYMPTOM-TO-FAULT DIAGNOSTIC MAPS™',
    body: 'Move from common appliance symptoms to possible causes through structured troubleshooting paths, checkpoints, component checks, testing decisions, and logical fault isolation.',
  },
  {
    label: '🎁 BONUS 4',
    title: 'APPLIANCE ELECTRICAL TROUBLESHOOTING GUIDE™',
    body: 'Follow electrical faults through power supply, protection, inputs, controls, wiring, connectors, and loads with practical electrical fault-finding references.',
  },
  {
    label: '🎁 BONUS 5',
    title: 'SERVICE CALL DIAGNOSTIC WORKSHEETS™',
    body: 'Organize appliance information, reported symptoms, inspections, diagnostic plans, component tests, measurements, findings, repairs, and post-repair verification with ready-to-use worksheets.',
  },
]
